import { render, staticRenderFns } from "./createPlugin.vue?vue&type=template&id=49f684fc&scoped=true"
import script from "./createPlugin.vue?vue&type=script&lang=js"
export * from "./createPlugin.vue?vue&type=script&lang=js"
import style0 from "./createPlugin.vue?vue&type=style&index=0&id=49f684fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f684fc",
  null
  
)

export default component.exports